// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as AnimatedRender from "../../primitives/AnimatedRender.res.js";
import * as CatalogProduct from "../Catalog/CatalogProduct.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ProductReferenceTableCell from "../Product/ProductReferenceTableCell.res.js";
import * as PromotionEditDiscountedProduct from "./PromotionEditDiscountedProduct.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query variantsDistinctOnCku($search: String, $after: String, $first: Int)  {\nvariantsDistinctOnCku(search: $search, after: $after, first: $first)  {\n__typename  \npageInfo  {\n__typename  \nendCursor  \nhasNextPage  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nid  \ncku  \ncreatedAt  \nformattedName  \nname  \nproduct  {\n__typename  \nid  \nname  \nkind  \ncolor  \nwineType  \nwhiteWineType  \nbeerType  \nproducer  \ndesignation  \nfamily  \nregion  \ncountry  \ntax  {\n__typename  \nvalue  \n}\n\n}\n\nstockKeepingUnit  \ninternalCode  \npriceLookUpCode  \nsupplier  {\n__typename  \ncompanyName  \n}\n\nformattedCategory  \nalcoholVolume  \ncapacityUnit  \nbulk  \npurchasedPrice  \nvariantPrices(first: 50)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nvalueIncludingTax  \nprice  {\n__typename  \nname  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.variantsDistinctOnCku;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.endCursor;
  let value$4 = value$2.hasNextPage;
  let value$5 = value$1.edges;
  return {
    variantsDistinctOnCku: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        endCursor: !(value$3 == null) ? value$3 : undefined,
        hasNextPage: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.product;
        let value$3 = value$2.kind;
        let tmp;
        switch (value$3) {
          case "BEER" :
            tmp = "BEER";
            break;
          case "SIMPLE" :
            tmp = "SIMPLE";
            break;
          case "SPIRITUOUS" :
            tmp = "SPIRITUOUS";
            break;
          case "WINE" :
            tmp = "WINE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$4 = value$2.color;
        let tmp$1;
        if (value$4 == null) {
          tmp$1 = undefined;
        } else {
          let tmp$2;
          switch (value$4) {
            case "AMBER" :
              tmp$2 = "AMBER";
              break;
            case "BLACK" :
              tmp$2 = "BLACK";
              break;
            case "BLOND" :
              tmp$2 = "BLOND";
              break;
            case "DARK" :
              tmp$2 = "DARK";
              break;
            case "ORANGE" :
              tmp$2 = "ORANGE";
              break;
            case "RED" :
              tmp$2 = "RED";
              break;
            case "ROSE" :
              tmp$2 = "ROSE";
              break;
            case "WHITE" :
              tmp$2 = "WHITE";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$1 = tmp$2;
        }
        let value$5 = value$2.wineType;
        let tmp$3;
        if (value$5 == null) {
          tmp$3 = undefined;
        } else {
          let tmp$4;
          switch (value$5) {
            case "EFFERVESCENT" :
              tmp$4 = "EFFERVESCENT";
              break;
            case "STILL" :
              tmp$4 = "STILL";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$3 = tmp$4;
        }
        let value$6 = value$2.whiteWineType;
        let tmp$5;
        if (value$6 == null) {
          tmp$5 = undefined;
        } else {
          let tmp$6;
          switch (value$6) {
            case "DRY" :
              tmp$6 = "DRY";
              break;
            case "SEMIDRY" :
              tmp$6 = "SEMIDRY";
              break;
            case "SOFT" :
              tmp$6 = "SOFT";
              break;
            case "SWEET" :
              tmp$6 = "SWEET";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$5 = tmp$6;
        }
        let value$7 = value$2.beerType;
        let value$8 = value$2.producer;
        let value$9 = value$2.designation;
        let value$10 = value$2.family;
        let value$11 = value$2.region;
        let value$12 = value$2.country;
        let value$13 = value$2.tax;
        let value$14 = value$1.stockKeepingUnit;
        let value$15 = value$1.internalCode;
        let value$16 = value$1.priceLookUpCode;
        let value$17 = value$1.supplier;
        let value$18 = value$1.formattedCategory;
        let value$19 = value$1.alcoholVolume;
        let value$20 = value$1.capacityUnit;
        let value$21 = value$1.bulk;
        let value$22 = value$1.purchasedPrice;
        let value$23 = value$1.variantPrices;
        let value$24 = value$23.edges;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            cku: Scalar.CKU.parse(value$1.cku),
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            formattedName: value$1.formattedName,
            name: value$1.name,
            product: {
              __typename: value$2.__typename,
              id: value$2.id,
              name: value$2.name,
              kind: tmp,
              color: tmp$1,
              wineType: tmp$3,
              whiteWineType: tmp$5,
              beerType: !(value$7 == null) ? value$7 : undefined,
              producer: !(value$8 == null) ? value$8 : undefined,
              designation: !(value$9 == null) ? value$9 : undefined,
              family: !(value$10 == null) ? value$10 : undefined,
              region: !(value$11 == null) ? value$11 : undefined,
              country: !(value$12 == null) ? value$12 : undefined,
              tax: {
                __typename: value$13.__typename,
                value: value$13.value
              }
            },
            stockKeepingUnit: !(value$14 == null) ? value$14 : undefined,
            internalCode: !(value$15 == null) ? value$15 : undefined,
            priceLookUpCode: !(value$16 == null) ? value$16 : undefined,
            supplier: !(value$17 == null) ? ({
                __typename: value$17.__typename,
                companyName: value$17.companyName
              }) : undefined,
            formattedCategory: !(value$18 == null) ? value$18 : undefined,
            alcoholVolume: !(value$19 == null) ? value$19 : undefined,
            capacityUnit: !(value$20 == null) ? value$20 : undefined,
            bulk: !(value$21 == null) ? value$21 : undefined,
            purchasedPrice: !(value$22 == null) ? value$22 : undefined,
            variantPrices: {
              __typename: value$23.__typename,
              edges: value$24.map(value => {
                let value$1 = value.node;
                let value$2 = value$1.price;
                return {
                  __typename: value.__typename,
                  node: {
                    __typename: value$1.__typename,
                    valueIncludingTax: value$1.valueIncludingTax,
                    price: !(value$2 == null) ? ({
                        __typename: value$2.__typename,
                        name: value$2.name
                      }) : undefined
                  }
                };
              })
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.variantsDistinctOnCku;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.variantPrices;
    let value$3 = value$2.edges;
    let edges = value$3.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.price;
      let price;
      if (value$2 !== undefined) {
        let value$3 = value$2.name;
        let value$4 = value$2.__typename;
        price = {
          __typename: value$4,
          name: value$3
        };
      } else {
        price = null;
      }
      let value$5 = value$1.valueIncludingTax;
      let value$6 = value$1.__typename;
      let node = {
        __typename: value$6,
        valueIncludingTax: value$5,
        price: price
      };
      let value$7 = value.__typename;
      return {
        __typename: value$7,
        node: node
      };
    });
    let value$4 = value$2.__typename;
    let variantPrices = {
      __typename: value$4,
      edges: edges
    };
    let value$5 = value$1.purchasedPrice;
    let purchasedPrice = value$5 !== undefined ? value$5 : null;
    let value$6 = value$1.bulk;
    let bulk = value$6 !== undefined ? value$6 : null;
    let value$7 = value$1.capacityUnit;
    let capacityUnit = value$7 !== undefined ? value$7 : null;
    let value$8 = value$1.alcoholVolume;
    let alcoholVolume = value$8 !== undefined ? value$8 : null;
    let value$9 = value$1.formattedCategory;
    let formattedCategory = value$9 !== undefined ? value$9 : null;
    let value$10 = value$1.supplier;
    let supplier;
    if (value$10 !== undefined) {
      let value$11 = value$10.companyName;
      let value$12 = value$10.__typename;
      supplier = {
        __typename: value$12,
        companyName: value$11
      };
    } else {
      supplier = null;
    }
    let value$13 = value$1.priceLookUpCode;
    let priceLookUpCode = value$13 !== undefined ? value$13 : null;
    let value$14 = value$1.internalCode;
    let internalCode = value$14 !== undefined ? value$14 : null;
    let value$15 = value$1.stockKeepingUnit;
    let stockKeepingUnit = value$15 !== undefined ? value$15 : null;
    let value$16 = value$1.product;
    let value$17 = value$16.tax;
    let value$18 = value$17.value;
    let value$19 = value$17.__typename;
    let tax = {
      __typename: value$19,
      value: value$18
    };
    let value$20 = value$16.country;
    let country = value$20 !== undefined ? value$20 : null;
    let value$21 = value$16.region;
    let region = value$21 !== undefined ? value$21 : null;
    let value$22 = value$16.family;
    let family = value$22 !== undefined ? value$22 : null;
    let value$23 = value$16.designation;
    let designation = value$23 !== undefined ? value$23 : null;
    let value$24 = value$16.producer;
    let producer = value$24 !== undefined ? value$24 : null;
    let value$25 = value$16.beerType;
    let beerType = value$25 !== undefined ? value$25 : null;
    let value$26 = value$16.whiteWineType;
    let whiteWineType = value$26 !== undefined ? (
        value$26 === "SWEET" ? "SWEET" : (
            value$26 === "SEMIDRY" ? "SEMIDRY" : (
                value$26 === "SOFT" ? "SOFT" : "DRY"
              )
          )
      ) : null;
    let value$27 = value$16.wineType;
    let wineType = value$27 !== undefined ? (
        value$27 === "EFFERVESCENT" ? "EFFERVESCENT" : "STILL"
      ) : null;
    let value$28 = value$16.color;
    let color = value$28 !== undefined ? (
        value$28 === "ORANGE" ? "ORANGE" : (
            value$28 === "RED" ? "RED" : (
                value$28 === "AMBER" ? "AMBER" : (
                    value$28 === "DARK" ? "DARK" : (
                        value$28 === "BLACK" ? "BLACK" : (
                            value$28 === "BLOND" ? "BLOND" : (
                                value$28 === "ROSE" ? "ROSE" : "WHITE"
                              )
                          )
                      )
                  )
              )
          )
      ) : null;
    let value$29 = value$16.kind;
    let kind = value$29 === "SPIRITUOUS" ? "SPIRITUOUS" : (
        value$29 === "BEER" ? "BEER" : (
            value$29 === "WINE" ? "WINE" : "SIMPLE"
          )
      );
    let value$30 = value$16.name;
    let value$31 = value$16.id;
    let value$32 = value$16.__typename;
    let product = {
      __typename: value$32,
      id: value$31,
      name: value$30,
      kind: kind,
      color: color,
      wineType: wineType,
      whiteWineType: whiteWineType,
      beerType: beerType,
      producer: producer,
      designation: designation,
      family: family,
      region: region,
      country: country,
      tax: tax
    };
    let value$33 = value$1.name;
    let value$34 = value$1.formattedName;
    let value$35 = value$1.createdAt;
    let value$36 = Scalar.Datetime.serialize(value$35);
    let value$37 = value$1.cku;
    let value$38 = Scalar.CKU.serialize(value$37);
    let value$39 = value$1.id;
    let value$40 = value$1.__typename;
    let node = {
      __typename: value$40,
      id: value$39,
      cku: value$38,
      createdAt: value$36,
      formattedName: value$34,
      name: value$33,
      product: product,
      stockKeepingUnit: stockKeepingUnit,
      internalCode: internalCode,
      priceLookUpCode: priceLookUpCode,
      supplier: supplier,
      formattedCategory: formattedCategory,
      alcoholVolume: alcoholVolume,
      capacityUnit: capacityUnit,
      bulk: bulk,
      purchasedPrice: purchasedPrice,
      variantPrices: variantPrices
    };
    let value$41 = value.__typename;
    return {
      __typename: value$41,
      node: node
    };
  });
  let value$3 = value$1.pageInfo;
  let value$4 = value$3.hasNextPage;
  let hasNextPage = value$4 !== undefined ? value$4 : null;
  let value$5 = value$3.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$3.__typename;
  let pageInfo = {
    __typename: value$6,
    endCursor: endCursor,
    hasNextPage: hasNextPage
  };
  let value$7 = value$1.__typename;
  let variantsDistinctOnCku = {
    __typename: value$7,
    pageInfo: pageInfo,
    edges: edges
  };
  return {
    variantsDistinctOnCku: variantsDistinctOnCku
  };
}

function serializeVariables(inp) {
  let a = inp.search;
  let a$1 = inp.after;
  let a$2 = inp.first;
  return {
    search: a !== undefined ? a : undefined,
    after: a$1 !== undefined ? a$1 : undefined,
    first: a$2 !== undefined ? a$2 : undefined
  };
}

function makeVariables(search, after, first) {
  return {
    search: search,
    after: after,
    first: first
  };
}

function makeDefaultVariables() {
  return {
    search: undefined,
    after: undefined,
    first: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function keyExtractor(row) {
  return row.cku;
}

let Row = {
  keyExtractor: keyExtractor
};

function rowsFromEdgesData(data) {
  return data.map(edge => {
    let match = edge.node.capacityUnit;
    let match$1 = Stdlib_Option.getOr(edge.node.bulk, false);
    return {
      id: edge.node.id,
      cku: edge.node.cku,
      createdAt: edge.node.createdAt,
      formattedName: edge.node.formattedName,
      productKind: edge.node.product.kind,
      information: {
        productName: edge.node.product.name,
        variantName: edge.node.name,
        sku: edge.node.stockKeepingUnit,
        plu: Stdlib_Option.map(edge.node.priceLookUpCode, plu => plu.toString()),
        internalCode: edge.node.internalCode,
        color: edge.node.product.color,
        producerName: edge.node.product.producer,
        designation: edge.node.product.designation,
        productFamily: edge.node.product.family,
        wineType: edge.node.product.wineType,
        whiteWineType: edge.node.product.whiteWineType,
        beerType: edge.node.product.beerType,
        region: edge.node.product.region,
        country: Stdlib_Option.getOr(edge.node.product.country, "—"),
        categoryName: Stdlib_Option.getOr(edge.node.formattedCategory, "—"),
        supplierName: Stdlib_Option.map(edge.node.supplier, supplier => supplier.companyName),
        alcoholVolume: Stdlib_Option.map(edge.node.alcoholVolume, alcoholVolume => I18n.decimalFormat(undefined, undefined, 1, undefined, alcoholVolume) + "°")
      },
      bulkUnit: match !== undefined && match$1 ? match : undefined,
      purchasePrice: Stdlib_Option.getOr(edge.node.purchasedPrice, 0),
      retailPrices: Stdlib_Array.filterMap(edge.node.variantPrices.edges, param => {
        let variantPrice = param.node;
        let price = variantPrice.price;
        if (price !== undefined) {
          return {
            priceName: price.name,
            valueIncludingTax: variantPrice.valueIncludingTax
          };
        }
      })
    };
  });
}

let columns = [{
    key: "reference",
    name: I18n.t("Product"),
    render: param => {
      let product = param.data;
      let badgeNew = DateHelpers.diffInHours(new Date(), product.createdAt) <= 24 ? ({
          variation: "information",
          text: I18n.t("New")
        }) : undefined;
      return JsxRuntime.jsx(ProductReferenceTableCell.make, {
        badge: badgeNew,
        disabled: param.disabled,
        errorMessage: param.errorMessage,
        productKind: product.productKind,
        information: product.information
      });
    }
  }];

let make = React.memo(props => {
  let onCommit = props.onCommit;
  let selectedProducts = props.selectedProducts;
  let selectedPriceName = props.selectedPriceName;
  let renderStartText = () => {
    let length = selectedProducts.length;
    let shouldBePrimaryView = length > 0;
    let formattedText = length.toString() + ` ` + I18n.t(I18n.isPlural(length) ? "selected products" : "selected product");
    return JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: formattedText,
        variation: shouldBePrimaryView ? "primary" : "neutral",
        weight: shouldBePrimaryView ? "strong" : "regular"
      })
    });
  };
  let onCommit$1 = () => onCommit(selectedProducts.map(row => PromotionEditDiscountedProduct.make(row.id, row.cku, row.formattedName, CatalogProduct.Information.formatDescription(row.productKind, row.information, undefined, undefined, undefined, undefined), row.information.sku, row.purchasePrice, row.bulkUnit, row.retailPrices.map(param => [
    param.priceName,
    param.valueIncludingTax
  ]), selectedPriceName)));
  return JsxRuntime.jsx(Modal.make, {
    children: props.children,
    opened: props.opened,
    title: I18n.t("Product append"),
    variation: "secondary",
    compact: false,
    backgroundColor: "#fefefe",
    renderStartText: renderStartText,
    abortButtonText: I18n.t("Cancel"),
    allowCommit: selectedProducts.length !== 0,
    commitButtonTone: "brand",
    commitButtonText: I18n.t("Add products"),
    commitButtonCallback: onCommit$1,
    onRequestClose: props.onRequestClose
  });
});

let PickerModal = {
  make: make
};

function makeVariables$1(search, after, param) {
  return {
    search: search,
    after: after,
    first: 20
  };
}

function initialState() {
  return {
    searchQuery: "",
    selectedProducts: []
  };
}

function make$1(state, action) {
  if (action.TAG === "Searched") {
    return {
      searchQuery: action._0,
      selectedProducts: state.selectedProducts
    };
  }
  let allProducts = action._1;
  let tableSelection = action._0;
  let prev = state.selectedProducts;
  let selectedProducts;
  selectedProducts = typeof tableSelection !== "object" ? prev : Stdlib_Array.filterMap(tableSelection._0, selectedRowCku => allProducts.concat(prev).find(row => row.cku === selectedRowCku));
  return {
    searchQuery: state.searchQuery,
    selectedProducts: selectedProducts
  };
}

let Reducer = {
  initialState: initialState,
  make: make$1
};

function PromotionEditDiscountedProductPickerModalTable(props) {
  let __disabledIds = props.disabledIds;
  let opened = props.opened;
  let disabledIds = __disabledIds !== undefined ? __disabledIds : [];
  let initialState_selectedProducts = [];
  let initialState = {
    searchQuery: "",
    selectedProducts: initialState_selectedProducts
  };
  let match = React.useReducer(make$1, initialState);
  let dispatch = match[1];
  let state = match[0];
  let query = use(undefined, undefined, undefined, undefined, "NetworkOnly", "CacheFirst", undefined, true, undefined, undefined, undefined, undefined, undefined, undefined, makeVariables$1(state.searchQuery, undefined, undefined));
  let asyncResult = ApolloHelpers.useQueryResultToAsyncResultWithVariablesReloading1(query, state.searchQuery);
  let data = AsyncResult.mapOk(asyncResult, data => rowsFromEdgesData(data.variantsDistinctOnCku.edges));
  React.useEffect(() => {
    if (!opened && state.searchQuery !== "") {
      dispatch({
        TAG: "Searched",
        _0: ""
      });
    }
  }, [opened]);
  let onLoadMore = React.useCallback(() => {
    if (typeof asyncResult !== "object") {
      return;
    }
    if (asyncResult.TAG !== "Done") {
      return;
    }
    let data = asyncResult._0;
    if (data.TAG !== "Ok") {
      return;
    }
    let data$1 = data._0;
    if (data$1.variantsDistinctOnCku.pageInfo.hasNextPage === true) {
      query.fetchMore(undefined, undefined, makeVariables$1(state.searchQuery, data$1.variantsDistinctOnCku.pageInfo.endCursor, undefined), (prevResult, param) => {
        let fetchMoreResult = param.fetchMoreResult;
        if (fetchMoreResult === undefined) {
          return prevResult;
        }
        let newVariants = fetchMoreResult.variantsDistinctOnCku;
        return {
          variantsDistinctOnCku: {
            __typename: newVariants.__typename,
            pageInfo: newVariants.pageInfo,
            edges: Belt_Array.concatMany([
              prevResult.variantsDistinctOnCku.edges,
              newVariants.edges
            ])
          }
        };
      }, undefined);
      return;
    }
  }, [asyncResult]);
  let onSelectChange = React.useCallback(selection => {
    let rowsData;
    if (typeof data !== "object") {
      rowsData = data === "NotAsked" ? [] : [];
    } else if (data.TAG === "Reloading") {
      let data$1 = data._0;
      rowsData = data$1.TAG === "Ok" ? data$1._0 : [];
    } else {
      let data$2 = data._0;
      rowsData = data$2.TAG === "Ok" ? data$2._0 : [];
    }
    dispatch({
      TAG: "ProductSelectionUpdated",
      _0: selection,
      _1: rowsData
    });
  }, [
    data,
    disabledIds
  ]);
  let placeholderEmptyState = JsxRuntime.jsx(EmptyState.make, {
    illustration: Illustration.noResultFound,
    title: I18n.t("No result were found."),
    text: I18n.t("Try again with another keyword or:"),
    children: JsxRuntime.jsx(Button.make, {
      label: I18n.t("Clear search query"),
      onPress: () => dispatch({
        TAG: "Searched",
        _0: ""
      })
    })
  });
  return JsxRuntime.jsx(make, {
    children: JsxRuntime.jsx(AnimatedRender.make, {
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(TableView.make, {
          data: data,
          columns: columns,
          keyExtractor: keyExtractor,
          disabledRowsKeys: disabledIds,
          selectionEnabled: true,
          selectAllEnabled: false,
          hideReloadingPlaceholder: true,
          compactRows: true,
          placeholderEmptyState: placeholderEmptyState,
          searchQuery: state.searchQuery,
          searchPlaceholder: I18n.t("Search product"),
          onSearchQueryChange: value => dispatch({
            TAG: "Searched",
            _0: value
          }),
          onLoadMore: onLoadMore,
          onSelectChange: onSelectChange
        }),
        style: {
          display: "flex",
          maxHeight: "70vh",
          minHeight: "70vh"
        }
      }),
      displayed: opened,
      animation: "fadePopinTranslation",
      duration: 300
    }),
    opened: opened,
    selectedPriceName: props.selectedPriceName,
    selectedProducts: state.selectedProducts,
    onCommit: props.onCommit,
    onRequestClose: props.onRequestClose
  });
}

let make$2 = React.memo(PromotionEditDiscountedProductPickerModalTable, (oldProps, newProps) => oldProps.opened === newProps.opened);

export {
  Query,
  Row,
  rowsFromEdgesData,
  columns,
  PickerModal,
  makeVariables$1 as makeVariables,
  Reducer,
  make$2 as make,
}
/* query Not a pure module */
